/* global JQuery */
import { Badge2, BadgeType2, UtilColor, Widget2 } from 'bambooo';
/**
 * SpeciesGroupDisplay
 */
export class SpeciesGroupDisplay extends Widget2 {
    constructor(element, group) {
        super({ element: jQuery('<span/>') });
        this._badge = new Badge2({ type: BadgeType2.info, color: group.color });
        this._badge.appendTo(SpeciesGroupDisplay._asParent(element));
        this._badge.getElement().html(`<b style="color: ${UtilColor.getContrastYIQ(group.color)}">${group.name}</b>`);
        this._element = this._badge.getElement();
    }
    /**
     * Resolve a parent (bambooo component, jQuery or selector) to a jQuery
     * handle the badge can be appended to.
     * @param {ComponentType} element
     * @return {JQuery}
     * @protected
     */
    static _asParent(element) {
        const maybe = element;
        if (maybe && typeof maybe.getElement === 'function') {
            return maybe.getElement();
        }
        return jQuery(element);
    }
}
